const faqData = [
  {
    question: "Why should I take the Carz Bazzar Franchise?",
    answer:
      "Carz Bazzar, India's largest organized used car player, offers high-intent, quality leads;integral to our franchise model. Joining our franchise presents a chance to join the revolution and expand your business, with the privilege of exclusive Carz Bazzar branding at your dealership",
  },
  {
    question: "Does a potential franchise partner need to be a used car dealer?",
    answer:
      "No, being a used car dealer is not mandatory for partnership. Anyone eager to enter used car sales, committed to increasing monthly earnings, can join Carz Bazzar, subject to agreement with the Carz Bazzar franchise screening process",
  },
  {
    question: "How does Carz Bazzar determine the suitability of a potential franchise partner?",
    answer:
      "Carz Bazzar employs a screening process to evaluate partner alignment with operational standards, financial capability, and time commitment for daily business operations.",
  },
  {
    question: "What fees are required for partners to pay to Carz Bazzar?",
    answer:
      "Franchise partners need to pay onboarding fees, refundable security deposits, monthly fees, and lead costs to Carz Bazzar, ensuring their commitment and operational support.",
  },
  {
    question: "Can dealers sell cars directly to customers under the Carz Bazzar brand within the franchise agreement?",
    answer:
      "The Carz Bazzar franchise model focuses on car procurement, not direct sales under the Carz Bazzar brand. Dealers are prohibited from selling cars to customers under the Carz Bazzar brand within this agreement. Any such sales will be deemed a breach of the agreement and addressed accordingly",
  },
  {
    question: "Will co branding be allowed for the franchise partner?",
    answer:
      "The franchise outlet will feature Carz Bazzar branding alongside the partner's name. However, the partner is not authorized to use Carz Bazzar branding at any other location or for other purposes, such as another store or car selling activities.",
  },
  {
    question: "How does Carz Bazzar handle territory exclusivity and the presence of multiple franchises in a region?",
    answer:
      "Exclusivity is not typically part of the agreement; usually, only one franchise operates in a region to effectively manage potential leads. However, in areas with exceptionally high demand that cannot be served by one partner, multiple franchises may be considered",
  },
];

const FaqSection = () => {
  return (
    <section className="bg-gray-50 py-20">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="text-center text-4xl font-bold text-gray-900 mb-16">
          Frequently asked questions
        </h2>
        
        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <details className="group">
                <summary className="flex justify-between items-center p-6 cursor-pointer hover:bg-gray-50 transition-colors">
                  <h3 className="text-lg font-semibold text-gray-900 pr-4">
                    {item.question}
                  </h3>
                  <div className="flex-shrink-0">
                    <svg 
                      className="w-5 h-5 text-gray-500 transition-transform duration-200 group-open:rotate-180" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </summary>
                <div className="px-6 pb-6 pt-0">
                  <div className="border-t border-gray-100 pt-4">
                    <p className="text-gray-700 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </details>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
